export default __webpack_public_path__ + "static/melting-45c2e7a42fdeb25fa6efd4834188af8d.png";